import styled, { css } from 'styled-components';

import { breakpoints } from '@notino/react-styleguide';

export const ReviewsWrapper = styled('div')`
  margin-top: 1.25rem;

  @media (min-width: ${breakpoints.lg}) {
    margin-top: 3rem;
  }
`;

export const ReviewCount = styled('span')`
  @media (min-width: ${breakpoints.lg}) {
    display: none;
  }
`;

export const TitleCSS = css`
  text-align: left !important;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  flex-basis: 100%;
  margin-bottom: 1rem;
  gap: 0.4rem;

  font-size: 1rem;
  line-height: 1.18;
  font-weight: bold;

  @media (min-width: ${breakpoints.md}) {
    font-size: 1.75rem !important;
    display: block;
    cursor: text;
    margin-bottom: 2rem;
  }
`;

export const TitleWrapper = styled.div`
  ${TitleCSS};
`;
